export const getLmbcList = (state: any) => state.lmbc.lmbc.list;
